
        import Header from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250204-c9c27144/ui-products/wk/aan/node_modules/ui-theme/components/header/index';  
import Scrolling from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250204-c9c27144/ui-products/wk/components/header/scrolling';  
import QuickSearch from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250204-c9c27144/ui-products/wk/widgets/quick-search/index';  
const main = (UX) => {
    const $header = document.querySelector('.main-header'),
        $scrolling = document.querySelector('.main-header')

try {
        if ($header ) {
            UX.header = new Header($header).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($scrolling ) {
            UX.scrolling = new Scrolling($scrolling).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.quickSearch = new QuickSearch().initialize()
    } catch (err) {
        console.error(err);
    }
    
}

        export default main;
        